import React from 'react';
import Profile from 'assets/head_spin_yellow_bg.gif';
import { ManPage } from 'components/ManPage/ManPage';

const rotations = [0, 90, 180, 270];

export class AssetWall extends React.Component {
  render(): React.ReactNode {
    return (
      <ManPage
        name="assets"
        manual="Rotating Heads"
        sections={[
          { heading: 'NAME', body: 'assets - rotating head wall' },
          {
            heading: 'GRID',
            body: (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 100px)', gap: 8 }}>
                {Array.from({ length: 24 }, (_, i) => (
                  <img
                    key={i}
                    src={Profile}
                    width="100"
                    style={{ transform: `rotate(${rotations[i % 4]}deg)` }}
                    alt="Moving head"
                  />
                ))}
              </div>
            )
          }
        ]}
      />
    );
  }
}
